export default ($axios) => ({
    $axios,

    async fetch({
        id,
        query,
    }) {
        return await $axios.get(`/services/${id}/materials${query}`)
    },

    async fetchById(id) {
        return await $axios.get(`/materials/${id}`)
    },

    async fetchIcons() {
        return await $axios.get('/materials/icons')
    },

    async create(form) {
        return await $axios.post('/materials', form)
    },

    async update(id, form) {
        return await $axios.put(`/materials/${id}`, form)
    },

    async remove(id) {
        return await $axios.delete(`/materials/${id}`)
    },
})
